import { Api } from "@/api";
import { PricingType, UserLoginType } from "@/DTO";
import { ConvertToPricingType } from "@/api/pricing/get";

export const GetPricingList = (user: UserLoginType) => {
  return new Promise<{
    data: PricingType[]
  }>((resolve, reject) => {
    const api = new Api({
      method: "get",
      path: `pricing`,
      header: {
        Authorization: "Bearer " + user.accessToken,
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: ConvertToPricingListType(data.data)
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};

export const ConvertToPricingListType = (data: any[]): PricingType[] => {
  const returnData = data.map((item) => {
    return ConvertToPricingType(item);
  });
  return returnData;
};

